import { useEffect } from "react";

/** Sets the document title and meta description for the page, restoring the previous values on unmount. */
const usePageMeta = (title, description) => {
  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content");

    document.title = title;
    if (meta && description) meta.setAttribute("content", description);
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });

    return () => {
      document.title = previousTitle;
      if (meta && previousDescription != null)
        meta.setAttribute("content", previousDescription);
    };
  }, [title, description]);
};

export default usePageMeta;
